import { useEffect, useState } from 'react';
import { getMyWallet, getMyReferralStats } from '../wallet/api';

const fmt = (n) =>
    new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 0 }).format(
        Number(n) || 0
    );

// === [ADDED] دریافت پراپ برای مدیریت باز و بسته شدن درخت ===
export default function ReferralSummaryWidget({ onToggleTree, isTreeOpen }) {
// ===========================================================
    const [stats, setStats] = useState(null);
    const [wallet, setWallet] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            try {
                const [statsData, walletData] = await Promise.all([
                    getMyReferralStats(),
                    getMyWallet(),
                ]);
                if (cancelled) return;
                setStats(statsData);
                setWallet(walletData);
            } catch (e) {
                console.error('Referral summary load failed:', e);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();
        return () => {
            cancelled = true;
        };
    }, []);

    if (loading) {
        return (
            <div className="referral-widget referral-widget-loading">
                <span>در حال بارگذاری...</span>
            </div>
        );
    }

    return (
        <div className="referral-widget">
            <div className="referral-widget-header">
                <div>
                    <h3>🎁 باشگاه معرف‌ها</h3>
                    <p>آمار معرفی‌ها و درآمد شما از بازاریابی.</p>
                </div>
            </div>

            <div className="referral-widget-stats">
                <div className="referral-widget-stat" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                    <span className="referral-widget-stat-label">موجودی کیف پول</span>
                    <strong className="referral-widget-stat-value">
                        {fmt(wallet?.balance)} ریال
                    </strong>
                </div>
                <div className="referral-widget-stat" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                    <span className="referral-widget-stat-label">معرفی موفق</span>
                    <strong className="referral-widget-stat-value">
                        {fmt(stats?.total_count)} نفر
                    </strong>
                </div>
                <div className="referral-widget-stat" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                    <span className="referral-widget-stat-label">کل درآمد</span>
                    <strong className="referral-widget-stat-value text-success">
                        {fmt(stats?.total_earned)} ریال
                    </strong>
                </div>
            </div>

            {/* === [CHANGED] تبدیل لینک به دکمه برای باز کردن درخت در همین صفحه === */}
            <div style={{ marginTop: '1.2rem', textAlign: 'center' }}>
                <button
                    type="button"
                    onClick={onToggleTree}
                    style={{
                        display: 'block',
                        width: '100%',
                        background: isTreeOpen ? '#e2e8f0' : '#eff6ff',
                        color: isTreeOpen ? '#475569' : '#2563eb',
                        padding: '0.75rem',
                        borderRadius: '8px',
                        textDecoration: 'none',
                        fontSize: '0.95rem',
                        fontWeight: 'bold',
                        boxSizing: 'border-box',
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                >
                    {isTreeOpen ? 'بستن زنجیره معرفی' : 'مشاهده زنجیره معرفی'}
                </button>
            </div>
            {/* ===================================================================== */}
        </div>
    );
}